export default {
	"refund.ParameterError": "Parameter error!",
	"refund.refundTime": "refund time",
	"refund.growBeans": "grow beans",
	"refund.totalRefund": "total refund",
	"refund.refundAmount": "refund amount"
}